export default {
  loading: {
    id: 'bo_seller-homepage-loading',
    defaultMessage: 'Loading...',
  },
  viewDetails: {
    id: 'bo_seller-homepage-opportunities-view_details',
    defaultMessage: 'View details',
  },
  tradeinOpportunities: {
    id: 'bo_seller.homepage.tradein_opportunities_title',
    defaultMessage: 'Trade-in',
  },
  tradeinOpportunitiesTag: {
    id: 'bo_seller.homepage.tradein_opportunities_tag',
    defaultMessage: '{total} sourcing opportunities',
  },
  tradeinOpportunitiesDescription: {
    id: 'bo_seller.homepage.tradein_opportunities_description',
    defaultMessage:
      'Sell more by sourcing high-demand products.Sell more by sourcing high-demand products.',
  },
}
